export default "__VITE_ASSET__BJ_jW_np__"